export default "__VITE_ASSET__JYxJQdgE__"